var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Lista zamówień " + _vm._s(_vm.serviceType))]),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pr-2", attrs: { md: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { placeholder: "Szukaj" },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-col",
            { staticClass: "pl-2", attrs: { md: "6", cols: "12" } },
            [
              _c("v-combobox", {
                attrs: {
                  label: "Status",
                  multiple: "",
                  placeholder: "Wszystkie",
                  "small-chips": "",
                  items: _vm.singleServiceOrderStatus
                },
                model: {
                  value: _vm.filterStatus,
                  callback: function($$v) {
                    _vm.filterStatus = $$v
                  },
                  expression: "filterStatus"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "table-less-padding",
        attrs: {
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false,
          headers: _vm.headers,
          items: _vm.filteredItems,
          "sort-by": _vm.pagination.sortBy,
          "sort-desc": _vm.pagination.descending,
          search: _vm.search,
          "custom-filter": _vm.filterOverAllProperty
        },
        on: {
          "update:sortBy": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sort-by": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sortDesc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          },
          "update:sort-desc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(props.item.company_name))]),
                  _c("td", [_vm._v(_vm._s(props.item.created_by_name))]),
                  _c("td", [_vm._v(_vm._s(props.item.created_at))]),
                  _c(
                    "td",
                    [
                      props.item.type === "hotel"
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.allRoomTypes().find(function(v) {
                                    return v.value === props.item.room_type
                                  }).text
                                ) +
                                " "
                            ),
                            _c("br"),
                            _c("b", [_vm._v(_vm._s(props.item.locationText))])
                          ])
                        : _vm._e(),
                      props.item.type === "flight"
                        ? _c("span", [
                            _vm._v(" Z "),
                            _c("b", [
                              _vm._v(_vm._s(props.item.startLocationText))
                            ]),
                            _vm._v(" do "),
                            _c("b", [
                              _vm._v(_vm._s(props.item.endLocationText))
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" Klasa: "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.allFlightClassTypes().find(function(v) {
                                    return v.value === props.item.seat_class
                                  }).text
                                )
                              )
                            ])
                          ])
                        : _vm._e(),
                      props.item.type === "rail"
                        ? _c("span", [
                            _vm._v(" Z "),
                            _c("b", [
                              _vm._v(_vm._s(props.item.startLocationText))
                            ]),
                            _vm._v(" do "),
                            _c("b", [
                              _vm._v(_vm._s(props.item.endLocationText))
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" Klasa: "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.allRailClassTypes().find(function(v) {
                                    return v.value === props.item.seat_class
                                  }).text
                                )
                              )
                            ])
                          ])
                        : _vm._e(),
                      props.item.type === "car"
                        ? _c("span", [
                            _vm._v(" Odbiór "),
                            _c("b", [
                              _vm._v(_vm._s(props.item.startLocationText))
                            ]),
                            props.item.endLocationText != null &&
                            props.item.endLocationText.length > 0
                              ? _c("span", [
                                  _vm._v(" zwrot "),
                                  _c("b", [
                                    _vm._v(_vm._s(props.item.endLocationText))
                                  ])
                                ])
                              : _vm._e(),
                            _c("br"),
                            _vm._v(" Klasa pojazdu: "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.allCarTypes().find(function(v) {
                                    return v.value === props.item.car_class
                                  }).text
                                )
                              )
                            ])
                          ])
                        : _vm._e(),
                      props.item.type === "other"
                        ? _c("span", [
                            _vm._v(" Usługa: "),
                            _c("b", [_vm._v(_vm._s(props.item.name))])
                          ])
                        : _vm._e(),
                      props.item.type === "insurance"
                        ? _c("span", [
                            _vm._v(" Ubezpieczenie: "),
                            _c("br"),
                            _c("b", [
                              _vm._v(
                                _vm._s(props.item.start_date) +
                                  " do " +
                                  _vm._s(props.item.end_date) +
                                  " "
                              ),
                              _c("br"),
                              _vm._v(
                                " " + _vm._s(props.item.locationText) + " "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" " + _vm._s(props.item.comment) + " "),
                      _c("br"),
                      _vm._v(" Dla: "),
                      _vm._l(props.item.users, function(user) {
                        return _c("span", { key: user.passenger_id }, [
                          _c("b", [
                            _vm._v(
                              _vm._s(user.name) + " " + _vm._s(user.surname)
                            )
                          ]),
                          _vm._v(", ")
                        ])
                      }),
                      props.item.cost_centre !== null &&
                      props.item.cost_centre !== ""
                        ? [
                            _c("br"),
                            _vm._v(" MPK: "),
                            _c("b", [_vm._v(_vm._s(props.item.cost_centre))])
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "td",
                    [
                      _c("single-service-order-chip", {
                        attrs: { status: props.item.status, text: null }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _vm._v(" " + _vm._s(props.item.order_group_id) + " "),
                      _vm._l(props.item.responsePerson, function(
                        responsePersonName
                      ) {
                        return _c("span", {
                          key: responsePersonName,
                          domProps: { textContent: _vm._s(responsePersonName) }
                        })
                      })
                    ],
                    2
                  ),
                  _c(
                    "td",
                    { staticClass: "text-no-wrap" },
                    [
                      [
                        _vm.itemsStatus.STATUS_CREATED,
                        _vm.itemsStatus.STATUS_READY_TO_SEND,
                        _vm.itemsStatus.STATUS_ALREADY_SEND
                      ].includes(props.item.status)
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                to:
                                                  "/admin/travel-service/item/edit/" +
                                                  props.item.id,
                                                icon: ""
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [_vm._v("assignment")])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_vm._v(" Zaofertuj zamówienie ")]
                          )
                        : _vm._e(),
                      [
                        _vm.itemsStatus.STATUS_CANCELED_BY_CLIENT,
                        _vm.itemsStatus.STATUS_BOOKING_CANCELLED,
                        _vm.itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL
                      ].includes(props.item.status)
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                to:
                                                  "/admin/travel-service/item/readonly/" +
                                                  props.item.id,
                                                icon: ""
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [_vm._v("assignment")])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_vm._v(" Podgląd oferty ")]
                          )
                        : _vm._e(),
                      [
                        _vm.itemsStatus.STATUS_OFFER_ACCEPTED_BY_CLIENT,
                        _vm.itemsStatus.STATUS_BOOKED,
                        _vm.itemsStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_BOOK
                      ].includes(props.item.status)
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                to:
                                                  "/admin/travel-service/add-booking/" +
                                                  props.item.id,
                                                icon: ""
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [_vm._v("assignment")])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_vm._v(" Dołącz rezerwację ")]
                          )
                        : _vm._e(),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            to:
                                              "/admin/travel-service/edit/" +
                                              props.item.order_service_id,
                                            icon: ""
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [_vm._v("remove_red_eye")])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" Przejdź do szczegółów całości zamówienia ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }